<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
    fill="#26A17B"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17.922 17.383V17.381C17.812 17.389 17.245 17.423 15.98 17.423C14.97 17.423 14.259 17.393 14.009 17.381V17.384C10.121 17.213 7.219 16.536 7.219 15.726C7.219 14.917 10.121 14.24 14.009 14.066V16.71C14.263 16.728 14.991 16.771 15.997 16.771C17.204 16.771 17.809 16.721 17.922 16.711V14.068C21.802 14.241 24.697 14.918 24.697 15.726C24.697 16.536 21.802 17.211 17.922 17.383ZM17.922 13.793V11.427H23.336V7.819H8.595V11.427H14.009V13.792C9.609 13.994 6.3 14.866 6.3 15.91C6.3 16.954 9.609 17.825 14.009 18.028V25.61H17.922V18.026C22.315 17.824 25.616 16.953 25.616 15.91C25.616 14.867 22.315 13.996 17.922 13.793Z"
    fill="#FFF"
  />
</svg>
